// ----- Start Smooth scrolling for tab links in pure JavaScript -----
document.querySelectorAll(".scroll-downtext").forEach(function(link) {
    link.addEventListener('click', function(event) {
        if (link.hash !== "") {
            event.preventDefault();
            const target = document.querySelector(link.hash);
            if (target) {
                window.scrollTo({
                    top: target.offsetTop,
                    behavior: 'smooth' 
                });
            }
        }
    });
});


// ----- End Smooth scrolling for tab links in pure JavaScript -----

// ----- Start Shop by Range -----
var swiper = new Swiper(".shopSwiper", {
    slidesPerView: 4, 
    spaceBetween: 30, 
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 30
      }
  }
});

// ----- End Shop by Range -----

// ----- Start Shop by industry -----
var swiper = new Swiper(".shopsSwiper", {
    slidesPerView: 4, 
    spaceBetween: 30, 
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 30
      }
  }
});

// ----- End Shop by industry -----

// ----- Start Home Review Silder -----
var swiper = new Swiper(".testimonial-slide", {
    slidesPerView: 3,
    // centeredSlides: true,
    spaceBetween: 30,
    // loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        0: {    
            slidesPerView: 1,
        },
        768: {    
            slidesPerView:2,
            spaceBetween: 15,
        },
        992: {    
            slidesPerView:3,
            spaceBetween: 30,
            // centeredSlides: true,
        }
    }
});
// ----- End Home Review Silder -----
// ----- Start Video Block Silder -----
var swiper = new Swiper(".video-slide", {
  slidesPerView: 5,
  centeredSlides: false,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 20
      }
  }
});

// Play Video Function
function playVideo(index) {
  var thumbnail = document.getElementById('thumbnail-' + index);
  var videoElement = document.getElementById('video-element-' + index);
  
  thumbnail.style.display = 'none';
  videoElement.style.display = 'block';
  videoElement.querySelector('video').play();
}

// ----- End Video Block Silder -----

// ----- Start Feature Collection Silder -----
var swiper = new Swiper(".featureSwiper", {
    slidesPerView: 4, 
    spaceBetween: 30, 
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 15
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 30
          }
      }
  });
// ----- End Feature Collection Silder -----


/* cart grid change image on hover */
class OptionSelectorCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.colorOptionSelector = this.querySelectorAll('button.color-option-btn');
    this.colorOptionSelector.forEach(button => {
      button.addEventListener('mouseover', this.onSelectHandleOption.bind(this));
      button.addEventListener('click', this.onSelectOptionMakeActive.bind(this));
    });
  }

  onSelectHandleOption() {
    const correntOptionSelctor = event.currentTarget;
    const imgURL = correntOptionSelctor.dataset.img;
    const productCard = this.closest('.product-card-wrapper');
    if(productCard){
      const imageElement = productCard.querySelector('.card__media img');
      if (imageElement) {
        imageElement.setAttribute('srcset', imgURL);
        imageElement.setAttribute('src', imgURL);
      }
    }
  }

  onSelectOptionMakeActive(){
    this.colorOptionSelector.forEach(button => {
      button.classList.remove('active');
    });
    const correntOptionSelctor = event.currentTarget;
    correntOptionSelctor.classList.add('active');
  }
}

customElements.define('cardproduct-option-selector', OptionSelectorCard);

/* end cart grid change image on hover */

/* Start Load More button in collection */
document.addEventListener('DOMContentLoaded', function () {
  let productGrid = document.querySelector('#product-grid');
  if(productGrid){
  let loadMoreBtn = document.querySelector('#loadMoreBtn');
  let nextPageUrl = productGrid.dataset.nextUrl;

  if (!nextPageUrl) {
    loadMoreBtn.style.display = 'none';
    return;
  }

  loadMoreBtn.addEventListener('click', async function () {
    loadMoreBtn.style.display = 'none';
    
    try {
      let response = await fetch(window.location.origin + nextPageUrl);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      let doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      let newItems = doc.querySelectorAll('#product-grid .grid__item');
      newItems.forEach(item => productGrid.append(item));

      nextPageUrl = doc.querySelector('#product-grid').dataset.nextUrl;
      if (nextPageUrl) loadMoreBtn.style.display = 'inline-block';

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  });
  }

//   document.querySelectorAll('.product__info-container variant-selects input').forEach(option => {
//    option.addEventListener('change', function(){
//       setTimeout(function(){
//           const current_vid = document.querySelector('.product-form.product-form input.product-variant-id').value;
//           console.log('current_vid ',current_vid);
//           const cost_price = document.querySelector(`.combine_product-variants option[data-id="${current_vid}"]`).value;
//           console.log('cost_price ',cost_price);
//           document.querySelector('input#cost-price').value = cost_price;
//       },500);
//    });
// });
});

// const getPrice = (selector) => {
//   const text = $(selector).last().text().replace('$', '').trim();
//   return parseFloat(text);
// };

// const updatePercentageDisplay = () => {
//   const regularPrice = getPrice('.price-item--regular');
//   const selectedPrice = getPrice('.price-item--sale');

//   if (!isNaN(regularPrice) && !isNaN(selectedPrice)) {
//     const percentage = Math.round((regularPrice - selectedPrice) / regularPrice * 100);
    
//     $('#percentage-display').text(`Save  ${percentage}%`).show();
//   } else {
//     $('#percentage-display').hide();
//   }
// };

// const changeProductOption = () => {
//   $('#percentage-display').hide();

//   setTimeout(() => {
//     const current_vid = document.querySelector('.product-form.product-form input.product-variant-id')?.value;
//     console.log('current_vid', current_vid);

//     const cost_price_elem = document.querySelector(`.combine_product-variants option[data-id="${current_vid}"]`);
//     const cost_price = cost_price_elem ? cost_price_elem.value : '';
//     console.log('cost_price', cost_price);

//     const costInput = document.querySelector('input#cost-price');
//     if (costInput) costInput.value = cost_price;

//     updatePercentageDisplay();
//   }, 1000);
// };

// $(document).ready(() => {
//   updatePercentageDisplay();
// });

const changeProductOption = () => {
  $('#percentage-display').hide();
  setTimeout(function(){
    $('#percentage-display').hide();

    const current_vid = document.querySelector('.product-form.product-form input.product-variant-id').value;
    console.log('current_vid ', current_vid);

    const cost_price = document.querySelector(`.combine_product-variants option[data-id="${current_vid}"]`).value;
    console.log('cost_price ', cost_price);

    document.querySelector('input#cost-price').value = cost_price;

    // Get the regular and sale prices (remove $ and commas)
    var regularPriceText = $('.price-item--regular').last().text().replace(/[$,]/g, '').trim();
    var selectedPriceText = $('.price-item--sale').first().text().replace(/[$,]/g, '').trim();

    var regularPrice = parseFloat(regularPriceText);
    var selectedPrice = parseFloat(selectedPriceText);

    console.log("Regular Price:", regularPrice, "Selected Price:", selectedPrice);

    if (!isNaN(regularPrice) && !isNaN(selectedPrice)) {
      var percentage = ((regularPrice - selectedPrice) / regularPrice) * 100;
      percentage = Math.round(percentage); // Rounded to whole number
      $('#percentage-display').text('Save ' + percentage + '%');
    }

    $('#percentage-display').show();
  }, 1000);
}

$(document).ready(function() {
  // Get the regular and sale prices (remove $ and commas)
  var regularPriceText = $('.price-item--regular').last().text().replace(/[$,]/g, '').trim();
  var selectedPriceText = $('.price-item--sale').first().text().replace(/[$,]/g, '').trim();

  var regularPrice = parseFloat(regularPriceText);
  var selectedPrice = parseFloat(selectedPriceText);

  console.log("Regular Price:", regularPrice, "Selected Price:", selectedPrice);

  if (!isNaN(regularPrice) && !isNaN(selectedPrice)) {
    var percentage = ((regularPrice - selectedPrice) / regularPrice) * 100;
    percentage = Math.round(percentage); // Rounded to whole number
    $('#percentage-display').text('Save ' + percentage + '%');
  }
});



/* End Load More button in collection */


